import {
  Component,
  Input,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  AfterContentChecked,
} from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-tab',
  template: `
    <div [hidden]="!active" class="pane">
      <ng-content></ng-content>
    </div>
  `,
  styles: [
    `
      .pane {
        padding: 0 1px;
      }
    `,
  ],
})
export class TabComponent implements AfterContentChecked {
  /**
   * @description
   * Tab is single tab for tabs component
   */

  /**
   * * Inputs
   * @header Text that will be displayed on tab
   * @active Is tab currently active
   */
  @Input() header: string;
  @Input() active = false;
  constructor(private cdr: ChangeDetectorRef) {}

  ngAfterContentChecked(): void {
    this.cdr.detectChanges();
  }
}
